import apiService from "./apiService";

const RemolquesService = {
  getRemolques: (lt_id) => apiService.get(`/api/v1/lineas-transporte/${lt_id}/remolques`),

 
};

export default RemolquesService;
